import { usePermission } from './usePermission';
import { useQuery, UseQueryOptions, QueryKey } from '@tanstack/react-query';

export function usePermissionQuery<TQueryFnData>(
  options: UseQueryOptions<TQueryFnData, unknown, TQueryFnData, QueryKey>
) {
  const isAdmin = usePermission();

  return useQuery({
    ...options,
    enabled: isAdmin && (options.enabled ?? true),
  });
}